import { ROUTES } from "../shared/utils";
import { Login, ResetPassword } from "../features/auth";
import { AuthLayout } from "../shared/layouts";

export const authRoutes = [
    {
        element: <AuthLayout />,
        children: [
            { path: ROUTES.LOGIN, element: <Login /> },
            { path: ROUTES.RESET_PASSWORD, element: <ResetPassword /> },
        ],
    },
];